var site = site || {};

(function ($) {
  $('html,body').addClass('quiz-loaded');
  var hide_chat = function () {
    if (site.client.isMobile === 1) {
      $('.LPMcontainer').addClass('hidden');
      $('.js-footer-sticky').addClass('hidden');
    }
  };

  if ($('body').hasClass('quiz-page-retailer')) {
    $.cookie('welcome15', '1', {
      expires: 1,
      path: '/'
    });
  }
  /* global MantleForm, MantleQuiz, JSBoot, generic */
  // function to pop Loading Results modal
  //
  var pop_loading = function ($loading) {
    $('body').addClass('quiz-loading-results');
    var options = {
      content: $loading,
      className: 'colorbox--quiz--loading',
      width: '100%',
      height: '100%',
      fixed: true
    };

    options['overlayClose'] = false;
    options['closeButton'] = false;

    options['onComplete'] = function () {
      $('html,body').addClass('no-scroll');
      $('html,body').addClass('overlay-active');
      $('html,body').addClass('quiz-loaded');

      $.colorbox.resize();
    };

    options['onCleanup'] = function () {
      $('html,body').removeClass('no-scroll');
      $('html,body').removeClass('overlay-active');
    };
    generic.overlay.launch(options);
  };

  $(document).on('quiz-scroll-to', function (e, top) {
    window.scrollTo({
      'top': top,
      'behavior': 'smooth'
    });
  });

  Drupal.behaviors.quizLandingPageFormatterV1 = {

    attach: function (context) {
      var $formatters = $('.js-quiz-landing-page-formatter', context);

      // disable autoscroll in chrome
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      $(window).on('unload', function () {
        $(window).scrollTop(0);
      });
      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $resultContainer = $('.js-quiz-landing-page-formatter__results', $formatter);
        var $loading = $('.js-quiz-landing-page-formatter__loading', $formatter);
        var $formContainer = $('.js-quiz-landing-page-quiz-form', $formatter);
        var form_name = $formatter.data('form-name');
        var quiz_info = window.__quiz_info__[form_name];
        var quiz_form = window.__quiz_form__[form_name];
        // var use_page_js is used in mustache.
        var use_page_js = $formatter.data('use-page-js');
        var init_state = $formatter.data('init-state');
        var $stickyFooter = $('.js-quiz-landing-page-footer-cta', $formatter);

        /*
         * This will set the height of quiz landing formatter since it is
         * fixed.
         */
        $formatter.on('mantle-form:set-height', function () {
          var quiz_top = $formatter.offset().top;
          var viewportHeight = $(window).height();
          var fixed_footer_cta = 0; // hardcoded for now
          var quizformatterHeight = viewportHeight - quiz_top - fixed_footer_cta;

          $formatter.height(quizformatterHeight);
          $formatter.css('min-height', quizformatterHeight);
        });

        /*
         * Trigger height setting for use during mobile since we're not taking
         * over the entire page. We want to consume the available space below
         * the footer.
         */
        $(window).on('resize scroll', _.debounce(function () {
          $formatter.trigger('mantle-form:set-height');
        }, 100));
        $formatter.trigger('mantle-form:set-height');

        $formatter.on('mantle-form:scroll-to-top', function () {
          // On desktop we scroll the div into view
          if ($(window).width() > 768) {
            var quiz_top = $formatter.offset().top;
            var window_top = $(window).scrollTop();

            // scroll to top if quiz top isn't in view
            if (quiz_top < window_top) {
              window.scrollTo({
                'top': 0,
                'behavior': 'smooth'
              });
            }

            return;
          }
          // mobile we scroll the fixed scroll container
          $('.js-quiz-landing-page-formatter__inner', $formatter).scrollTop(0);
        });

        $formatter.on('mantle-form:submit-requested', function () {
          pop_loading($loading);

          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');
          var form_answers = manager.gather_answers();
          // PG backed forms need to make a remote call.
          var save_promise = manager.save_answers(form_answers);
          var query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);

          query_string = 'show_results=1&' + query_string;
          $formatter.trigger('form-set-pushstate', [query_string]);

          save_promise.then(function () {
            $formatter.trigger('mantle-form:request-form-results', [form_answers, false]);
          });
        });

        $formatter.on('mantle-form:request-form-results', function (e, form_answers, show_loading) {
          if (!!show_loading) {
            pop_loading($loading);
          }
          var result_promise = MantleQuiz.rpc.get_quiz_results(form_name, form_answers);

          result_promise.then(function (result_html) {
            $formatter.trigger('mantle-quiz-render-results', [result_html]);
          });
          hide_chat();
        });

        $formatter.on('click', '.js-mantle-form-reset', function (e) {
          $(document).trigger('hairRequiz');
          e.preventDefault();
          var $forms = $('.js-form-formatter', $formatter);

          $forms.trigger('form-reset');
          $formatter.removeClass('show-results');
          $formatter.addClass('show-quiz');
          $formatter.trigger('mantle-form:scroll-to-top');
          location.reload();
          _init();
        });

        if (!init_state) {
          init_state = 'bare_form';
        }

        if (JSBoot.URL.getParam('init_state')) {
          init_state = JSBoot.URL.getParam('init_state');
        }

        // initialize the quiz form and quiz_info PGStates.
        MantleQuiz.quiz_info_state.getSubject(form_name, quiz_info);
        MantleQuiz.quiz_form_state.getSubject(form_name, quiz_form);

        $formatter.on('mantle-quiz-render-results', function (e, render_pack) {
          $resultContainer.html(render_pack.html);
          $('.js-quiz-landing-page-main-block').addClass('hidden');
          $formContainer.addClass('hidden');
          var loaded_func = function () {
            Drupal.attachBehaviors($resultContainer);
            window.setTimeout(function () {
              // we wait a bit to give time to load assets
              $formatter.trigger('mantle-quiz-reveal-results');
            }, 500);
          };

          MantleQuiz.render_pack_to(render_pack, {
            'target': $resultContainer,
            'loaded_func': loaded_func
          });
        });

        // Implements mantle-quiz-submit-requested
        $formatter.on('mantle-quiz-reveal-results', function () {
          $('body').removeClass('quiz-loading-results');
          $.colorbox.close();
          $formatter.addClass('show-results');
          $formatter.removeClass('show-quiz');
          hide_items();
          hide_chat();
          $formatter.trigger('mantle-form:scroll-to-top');
          $(document).trigger('hairQuizResult', 'allProdIds');
          window.setTimeout(function () {
            $formatter.trigger('mantle-form:reset-ios-scroll');
          }, 100);
        });

        var render_form = function (disable_form_active) {
          if (!!disable_form_active) {
            $formatter.attr('data-disable-default-form-set-active', 1);
          }
          var $form = $('.js-form-formatter', $formatter);

          if ($form.length === 0) {
            $formContainer.html(quiz_form.html);
            Drupal.attachBehaviors($formContainer);
          }
          if (!!disable_form_active) {
            $formatter.attr('data-disable-default-form-set-active', 0);
          }
        };
        var show_form = function () {
          $formatter.addClass('show-quiz');
          $formatter.removeClass('show-results');
        };
        var hide_items = function () {
          $('body').addClass('quiz-option-page');
          $('.form-step-track__back-link').addClass('hidden');
        };

        // Pop helper text on initial load.
        // TODO: hide this with cookie?
        $formatter.on('helper-text-initialized', '.js-mantle-form-options-field', function () {
          var $field = $(this);
          var field_name = $field.data('field-name');
          var helper_key = field_name + '_helper_seen';

          if ($formatter.data(helper_key)) {
            // already seen. don't show again.
            return;
          }
          var $link = $('.js-helper-text-link', $field);

          if ($link.length) {
            $link.click();
          }
          $formatter.data(helper_key, 1);
        });

        /*
         * Additional form reaction. TODO: move this into mantle_form. Put here
         * to expedite pushing since this is brand code.
         */
        $formatter.on('form-render-reactions', function () {
          $('.js-form-answer-reaction', $formatter).each(function (i, obj) {
            var $reaction = $(obj);

            if ($reaction.data('question-key')) {
              var question_key = $reaction.data('question-key');
              var reaction_type = 'text';

              if ($reaction.data('reaction-type')) {
                reaction_type = $reaction.data('reaction-type');
              }
              if (reaction_type === 'count-attr') {
                var $form = $('.js-form-formatter', $formatter).first();
                var manager = $form.data('form-manager');
                var $matched = manager.get_form_item_by_name(question_key);
                var slideCount = '';

                if ($('[data-slide-count]', $matched).length > 0) {
                  slideCount = $('[data-slide-count]', $matched).data('slide-count');
                  $reaction.attr('data-answer-count', slideCount);
                } else {
                  slideCount = $('mantle-form-options-field__item', $matched).length + 1;
                  $reaction.attr('data-answer-count', slideCount);
                }
              }
            }
          });
        });

        /*
         * Copy button from the form option to a sticky footer section.
         */
        $formatter.on('mantle-form:copy-button', function () {
          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');
          var $form_items = manager._form_items();
          var $active_field = $form_items.filter('.active');
          var $active_button = $('.mantle-form-options-field__footer-cta', $active_field);
          var $clone_button = $($active_button.html());

          $clone_button.data('original-button', $active_button);
          $stickyFooter.html($clone_button);
        });

        /*
         * After form js renders the button, recopy the button into the sticky
         * footer container.
         */
        $formatter.on('form-render-buttons', function () {
          $formatter.trigger('mantle-form:copy-button');
        });

        /*
         * Proxy the click the form options field.
         */
        $stickyFooter.on('click', '.js-mantle-cta-button', function (e) {
          e.preventDefault();
          var $clone_button = $(this);
          var $active_button = $clone_button.data('original-button');
          var $cta_button = $('.js-mantle-cta-button', $active_button);

          $cta_button.click();
        });

        $formatter.on('mantle-form:reset-ios-scroll', function () {
          // The ios overflow touch seems to be heavily optimized. For dynamic
          // content, you need to reset the overflow setting to re-enable the
          // scrollbar.
          // instead of detecting ios directly. Just do a mobile check. This is
          // really only to fix IE11.
          if ($(window).width() > 768) {
            return;
          }
          var $scrollContainer = $('.js-quiz-landing-page-formatter__inner', $formatter);

          $scrollContainer.css('overflow-y', 'visible');
          window.setTimeout(function () {
            $scrollContainer.css('overflow-y', 'auto');
          }, 10);
        });

        $formatter.on('form-set-active-done', function (e, field_name, form_answers) {
          $formatter.trigger('mantle-form:scroll-to-top');
          $formatter.trigger('mantle-form:copy-button');
          window.setTimeout(function () {
            $formatter.trigger('mantle-form:reset-ios-scroll');
          }, 100);

          if ($formatter.data('refreshing-from-url') === 1) {
            return;
          }

          var _query_string = MantleForm.from_answers_to_query_string(form_answers, quiz_info);
          var query_string = '';

          if (field_name !== 'intro') {
            query_string = '_step=' + field_name;
            hide_items();
          }
          if (_query_string) {
            query_string = query_string + '&' + _query_string;
          }
          $formatter.trigger('form-set-pushstate', [query_string]);
          hide_chat();
        });

        $formatter.on('form-set-pushstate', function (e, query_string) {
          var stateObj = {
          };
          var new_url = window.location.pathname;
          var urlParams = window.location.search;
          var currentStep = JSBoot.URL.getParam('_step');
          var isIntroPage = (currentStep === null || currentStep === 'intro') && JSBoot.URL.getParam('show_results') !== '1' ? true : false;

          if (!_.isEmpty(query_string)) {
            new_url = new_url + '?' + query_string;
          } else if (urlParams.length >= 0 && isIntroPage) {
            new_url = new_url + urlParams;
          }

          history.pushState(stateObj, '', new_url);
        });

        $formatter.on('refresh-from-url-state', function () {
          $formatter.data('refreshing-from-url', 1);
          var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
          var current_step = JSBoot.URL.getParam('_step');

          // disable forms default
          show_form();
          render_form(true);
          var $form = $('.js-form-formatter', $formatter).first();
          var manager = $form.data('form-manager');

          manager.save_answers_to_form_state(query_answers, false);
          manager.apply_answers_from_form_state(true);
          $form.trigger('form-set-active', [current_step]);
          $formatter.data('refreshing-from-url', 0);
        });

        window.onpopstate = function () {
          if (JSBoot.URL.getParam('_step')) {
            hide_items();
            $formatter.trigger('refresh-from-url-state', [false]);

            return;
          }
        };

        /*
         * This is the real init func
         */
        var _init = function () {
          var show_results = false;

          if (JSBoot.URL.getParam('show_results')) {
            hide_items();
            show_results = true;
          }

          // var form_data = MantleForm.get_form_data_from_form_state_manager(form_name);
          var query_answers = MantleForm.get_form_answers_from_query_string(quiz_info);
          var query_answers_valid = MantleForm.validate_form_answers_data(query_answers, quiz_info);

          if (query_answers_valid && show_results) {
            // don't trigger a push state
            $formatter.data('refreshing-from-url', 1);
            show_form();
            render_form(true);
            $formatter.trigger('mantle-form:request-form-results', [query_answers, true]);
            $formatter.data('refreshing-from-url', 0);

            return;
          }

          if (JSBoot.URL.getParam('_step')) {
            $formatter.trigger('refresh-from-url-state', [true]);

            return;
          }

          // The stuff below requires we have the user quiz state
          MantleQuiz.get_quiz_data(form_name).then(function (quiz_data) {
            // not answered. show quiz
            if (!quiz_data || !quiz_data.answered) {
              show_form();
              render_form();

              return;
            }

            show_form();
            render_form();

            return;
          });
        };

        // Run after all behaviors have attached.
        $(function () {
          _init();
        });
      });
    }
  };

  Drupal.behaviors.AVQuizHelperLink = {
    attach: function (context) {
      var $links = $('.js-helper-text-link', context);

      $links.each(function (i, obj) {
        var $link = $(obj);

        $link.on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          var $parent = $link.closest('.js-mantle-form-options-field');
          var $content = $('.mantle-form-options-field__helper-text', $parent);

          if ($content.length === 0) {
            return;
          }

          var options = {
            href: $content,
            className: 'colorbox--quiz colorbox--helper-text',
            escKey: false,
            inline: true, // retain state/events
            width: '535px'
          };

          options['onComplete'] = function () {
            $('.js-mantle-cta-button', $content).on('click.ugc-overlay', function () {
              $.colorbox.close();
            });
            $.colorbox.resize();
          };

          options['onCleanup'] = function () {
            $content.off('.ugc-overlay');
          };
          generic.overlay.launch(options);
        });

        $link.trigger('helper-text-initialized');
      });
    }
  };

  Drupal.behaviors.updateIosScrollbar = {
    attach: function (context) {
      // this is to handle ajax. On first load, fields should request an ios
      // scroll reset.
      var $option_fields = $('.js-mantle-form-options-field', context);

      if ($option_fields.length > 0) {
        window.setTimeout(function () {
          $option_fields.first().trigger('mantle-form:reset-ios-scroll');
        }, 100);
      }
    }
  };
})(jQuery);
